import { SvgIcon } from '@bob/library'
import { Asset, AssetProps } from '@websrc/App/Components/Asset/Asset'
import { WithBrand } from '@websrc/App/Components/WithBrand'
import { brand } from '@websrc/App/Helpers/brand'
import { useLocale } from '@websrc/App/Hooks/useLocale'
import clsx from 'clsx'
import { Link } from 'gatsby'
import { styles, typography } from 'leds'
import React, { useState } from 'react'

interface CompatibleWithProductProps {
  name: string
  image: AssetProps['thumbnail']
  url: string
}

export const CompatibleWithProduct: React.FC<CompatibleWithProductProps> = ({
  image,
  name,
  url,
}) => {
  const locale = useLocale()
  const [isHovered, setIsHovered] = useState(false)

  const textColor = isHovered ? 'blue5' : 'black'
  const productPath = `/${locale}/products`

  return (
    <Link
      className={clsx(
        styles({
          borderStyle: 'solid',
          borderColor: isHovered ? 'blue5' : 'grey4',
          borderWidth: 1,
          display: 'flex',
          marginBottom: 25,
          alignItems: 'center',
          borderRadius: 'small',
          padding: 10,
          gap: 20,
          cursor: 'pointer',
        })
      )}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      to={`${productPath}${url?.replace(productPath, '')}`}
    >
      <Asset height={64} thumbnail={image} />
      <div className={styles({ display: 'flex', flexDirection: 'column' })}>
        <WithBrand className={styles({ color: textColor })} title={'{brand}'} />
        <span
          className={typography({
            weight: 'bold',
            size: 'xl2',
            color: isHovered ? 'blue' : 'black',
          })}
        >
          {name.replace(brand.name, '')}
        </span>
      </div>
      <SvgIcon
        className={styles({ marginLeft: 'auto' })}
        color={textColor}
        name={'ARROW_RIGHT'}
        size={25}
        strokeWidth={4}
      />
    </Link>
  )
}
